exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container2{\r\n    width: 1200px; \r\n}\r\n\r\n.lp-con5 {\r\n    background: #242424;\r\n}\r\n\r\n.lp-con5-wrapper{\r\n    overflow: hidden;\r\n    color: #fff;\r\n    margin: 0 auto;\r\n    padding: 16px 0px;\r\n    font-size: 12px;\r\n    font-weight: 300;\r\n    letter-spacing: 2px;\r\n}\r\n\r\n.lp-con5 a {\r\n    color: #fff;\r\n    cursor: pointer;\r\n}\r\n\r\n.lp-con5 img {\r\n    cursor: pointer;\r\n}\r\n\r\n.lp-con5 a:hover {\r\n    text-decoration: underline;\r\n    color: #26B99A;\r\n}\r\n\r\n.footer {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n}\r\n\r\n.footer img {\r\n    width: 7%;\r\n}\r\n\r\n.right-aligned {\r\n    text-align: right;\r\n}\r\n\r\n.center-aligned {\r\n    text-align: center;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/components/landingpage-footer/landingpage-footer.component.css
// module id = ../../../../../src/app/components/landingpage-footer/landingpage-footer.component.css
// module chunks = 0